import React from "react";
import { useLocation } from "react-router";

import ActionBtn from "../../../common/management/ActionBtn";

import styles from "../../management/db-list/DBList.module.scss";

type Props = {
  name: string;
  count: number;
  slug: string;
};
const TaxonomyListItem: React.FC<Props> = ({ name, count, slug }) => {
  const { pathname } = useLocation();

  return (
    <div
      className={`${styles["f-dbList__category"]} ${styles["body"]} ${styles["taxonomy"]}`}
    >
      <div>{name}</div>
      <div>{count}</div>
      <ActionBtn label="追加する" link={`${pathname}/${slug}`} />
    </div>
  );
};

export default TaxonomyListItem;
